import React from 'react';
import LaunchIndividualHeader from './launch-individual-header';
import LaunchIndividualContent from './launch-individual-content';
import Stack from 'react-bootstrap/Stack';

function LaunchIndividual({ selectionMade }) {
  return (
    <Stack gap={1} className="h-100">
      <LaunchIndividualHeader />
      <LaunchIndividualContent selectionMade={selectionMade} />
    </Stack>
  );
}

export default LaunchIndividual;
